import { useId } from 'react';
import { cn } from '@/lib/utils';

const GLASS_OUTLINE_D =
  'M15,9 C13,15 12,21 12,27 C12,45 21,60 36,66 C51,60 60,45 60,27 C60,21 59,15 57,9';
const GLASS_CLIP_D = `${GLASS_OUTLINE_D} Z`;
const GLASS_PHASES = [0, 1, 2, 3] as const;

interface WineCarouselLoaderProps {
  label?: string;
  className?: string;
}

export function WineCarouselLoader({ label, className }: WineCarouselLoaderProps) {
  const baseId = useId();

  return (
    <div className={cn('flex flex-col items-center gap-3', className)} role="status">
      <div className="wine-carousel-frame">
        <div className="wine-carousel-counter" />
        <div className="wine-carousel-stream" />
        <div className="wine-carousel-ripple" />
        {GLASS_PHASES.map((phase) => {
          const clipId = `${baseId}-clip-${phase}`;
          const gradientId = `${baseId}-grad-${phase}`;
          return (
            <div
              key={phase}
              className="wine-carousel-glass"
              style={{ '--phase': phase } as React.CSSProperties}
            >
              <svg viewBox="0 0 72 96" aria-hidden="true">
                <defs>
                  <clipPath id={clipId}>
                    <path d={GLASS_CLIP_D} />
                  </clipPath>
                  <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#c94f5f" />
                    <stop offset="100%" stopColor="#5c1421" />
                  </linearGradient>
                </defs>
                <g clipPath={`url(#${clipId})`}>
                  <rect
                    className="wine-carousel-fill"
                    x="8"
                    y="9"
                    width="56"
                    height="80"
                    fill={`url(#${gradientId})`}
                  />
                </g>
                <path className="wine-carousel-outline" d={GLASS_OUTLINE_D} />
                <path className="wine-carousel-outline" d="M36,66 L36,82" />
                <path className="wine-carousel-outline" d="M22,86 L50,86" />
              </svg>
            </div>
          );
        })}
      </div>
      {label ? <span className="text-sm text-muted-foreground">{label}</span> : null}
    </div>
  );
}
